import React from 'react';
import { Modal  } from 'antd';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from './constants/style.constant';

import './styles.scss';

export default function CustomModal(props) {
	

	const country = props.country || Enviroment.COUNTRY;
	return (
			<Modal {...props} className={Dictionary[country][props?.className]}>
				
			</Modal>
	)
}